import { GraphQLAPI } from './GraphQLAPI';
import { GraphQLResult } from './types';
import { environment } from '../env';

const instance = new GraphQLAPI(environment.aws_appsync_graphqlEndpoint);

// TODO T = any durch T ersetzen
export async function makeGraphqlQuery<T = any>(query: string, variables: object, ignoreErrorTypes: string[] = []): Promise<T> {
  return instance.graphql<any>(query, variables).then((results: GraphQLResult) => {
    for (const item of results?.errors ?? []) {
      if (!ignoreErrorTypes.includes(item.errorType)) {
        throw new Error(item.message);
      }
    }
    const queryResults = Object.values(results.data ?? {})[0];
    return queryResults ?? null;
  });
}
